import { toast } from 'react-toastify';
import appApi from '../../../../api/app-api';
import globalCourseStore from '../../../../stores/global-course-store';
import { displayErrorText } from '../../../../api/errors/api-error-codes';
import axios from 'axios';

export const removeLecturerFromCourseOperation = async (
  programId: number | undefined,
  courseId: number | undefined,
  lecturerId: number,
  setLoading: (lecturerId: number | null) => void,
) => {
  try {
    if (!programId || !courseId) {
      toast.warn('לא ניתן לאתר את מזהה הקורס ו/או התוכנית, נסה שוב מאוחר יותר');
      return;
    }

    setLoading(lecturerId);
    const res = await appApi.removeLecturerFromCourse(
      programId,
      courseId,
      lecturerId,
    );
    if (res.data.errCode) {
      const errorMessage = displayErrorText(res.data.errCode);
      if (errorMessage) {
        toast.info(errorMessage);
        setLoading(null);
        return;
      }
    }

    // Update the state - remove the lecturer from the course
    globalCourseStore.removeLecturer(lecturerId);

    toast.success('המרצה הוסר מהקורס בהצלחה');
    setLoading(null);
  } catch (e) {
    setLoading(null);
    toast.error('התרחשה תקלה, נסה שוב בעוד מספר רגעים');
    console.error(`removeLecturerFromCourse failed with error: ${e}`);
  }
};
